<template>
  <ubi-panel>
    <el-container>
      <el-aside width="30%">
        <h3>{{ $t('posts.edit.infoGeoRisques') }}</h3>
        <p class="text-justify" v-html="$t('posts.edit.geoRisquesSubtitle')"/>
      </el-aside>
      <el-main>
        <el-row>
          <el-col :lg="24">
            <el-form-item :label="$labels.zone_georisque">
              <el-radio v-model="post.zone_georisque" label="oui">{{ $t("general.yes") }}</el-radio>
              <el-radio v-model="post.zone_georisque" label="non">{{ $t("general.no") }}</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </ubi-panel>
</template>

<script>
import UbiPanel from '../../../../components/Panel'

export default {
  name: 'GeoRisques',
  components: { UbiPanel },
  props: ['post', 'ddList'],
  computed: {

  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>

</style>
